import {observer} from 'mobx-react-lite'
import {Button, Typography, Tooltip} from '@mui/material'
import {getTypographyColor, OcButtonProps} from './utils'

function _OcButton(props: OcButtonProps) {
    const {typoVariant, typoColor: _typoColor, children, tooltip, fullWidth, ...restProps} = props
    return (
        <Tooltip title={tooltip || ''}>
            <span style={fullWidth ? {width: '100%'} : undefined}>
                <Button
                    {...restProps}
                    variant={props.variant ? props.variant : 'contained'}
                    color={props.color ? props.color : 'primary'}
                    style={fullWidth ? {...restProps.style, width: '100%'} : {...restProps.style}}
                >
                    <Typography variant={typoVariant ? typoVariant : 'body2'} color={getTypographyColor(props)}>
                        {children}
                    </Typography>
                </Button>
            </span>
        </Tooltip>
    )
}

export const OcButton = observer(_OcButton)
